/** Whether `window.history.back()` would be a silent no-op — i.e. there's no
 *  prior entry in the tab to return to.
 *
 *  Reads the router's own per-entry index (TanStack stamps every history
 *  entry with `window.history.state.__TSR_index`, starting at 0 on a fresh
 *  load). Index 0 — or an unknown index before the router has stamped one —
 *  is the tab's first entry: the page was opened in a new tab, deep-linked,
 *  or reloaded, so Back goes nowhere. Unlike `history.length`, the index is
 *  unaffected by forward entries, so it doesn't falsely report a back target
 *  when you're sitting at the start with forward history ahead. A Back
 *  control should route to a known fallback when this is true. */
export function historyBackIsNoop(entryIndex: number | null | undefined): boolean {
  return entryIndex === null || entryIndex === undefined || entryIndex <= 0;
}
